import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'

//使用路由
Vue.use(Router)

const routes = [
  {
    path: '',
    component: index,
    children: [
      {
        path: '/',
        redirect:'/find'
      },  
      {
        path: '/find',
        component: r => require(['@/views/Find'], r),
        meta:{keepAlive:true,isShare:true}
      }, {
        path: '/type',
        component: r => require(['@/views/Type'], r),
        meta:{keepAlive:true}
      }, {
        path: '/study',
        component: r => require(['@/views/Study'], r)
      }, {
        path: '/exchange',
        component: r => require(['@/views/Exchange'], r)
      }, {
        path: '/mine',
        component: r => require(['@/views/Mine'], r)
      }]
  },
  //搜索
  {
    path:'/search',
    component: r => require(['@/views/SearchList'], r),
    meta:{keepAlive:true}
  },
  {
    path:'/searchmore',
    component: r => require(['@/views/SearchMore'], r),
    meta:{keepAlive:true}
  },
  //登录、注册、修改密码、用户信息
  {
    path:'/user/login',
    component: r => require(['@/views/user/Login'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/user/wxlogin',
    component: r => require(['@/views/user/WXLogin'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/user/regist',
    component: r => require(['@/views/user/Regist'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/user/resetpwd',
    component: r => require(['@/views/user/Resetpwd'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/user/findpwd',
    component: r => require(['@/views/user/Findpwd'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/user/info',
    component: r => require(['@/views/user/User'], r),
    meta:{keepAlive:false}
  },
  //兑换
  {
    path:'/exchange/suit',
    component: r => require(['@/views/exchange/ExchangeSuit'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/suitsuccess',
    component: r => require(['@/views/exchange/ExchangeSuitSuccess'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/same',
    component: r => require(['@/views/exchange/ExchangeSameType'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/samemore',
    component: r => require(['@/views/exchange/ExchangeSameTypeMore'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/samesuccess',
    component: r => require(['@/views/exchange/ExchangeSameSuccess'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/msuccess',
    component: r => require(['@/views/exchange/ExchangeMemberSuccess'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/bsuccess',
    component: r => require(['@/views/exchange/ExchangeBookCardSuccess'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/exchange/share',
    component: r => require(['@/views/exchange/ExchangeShare'], r),
    meta:{keepAlive:false}
  },
  //我的关注
  {
    path:'/mine/myattendlist',
    component: r => require(['@/views/mine/MyAttendList'], r)
  },
   //我的订单
  {
    path:'/mine/myorderlist',
    component: r => require(['@/views/mine/MyOrderList'], r)
  },
  //我的收藏
  {
    path:'/mine/mycolllist',
    component: r => require(['@/views/mine/MyCollection'], r)
  },
  //兑换记录
  {
    path:'/mine/myexchglist',
    component: r => require(['@/views/mine/MyExchange'], r)
  },
  {
    path:'/mine/mycollmorelist',
    component: r => require(['@/views/mine/MyCollectionMore'], r)
  },
  //浏览历史
  {
    path:'/mine/myhislist',
    component: r => require(['@/views/mine/MyHistory'], r)
  },
  {
    path:'/mine/myhismorelist',
    component: r => require(['@/views/mine/MyHistoryMore'], r)
  },
  //购买会员
  {
    path:'/mine/join',
    component: r => require(['@/views/mine/JoinMember'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/mine/joinpay',
    component: r => require(['@/views/mine/JoinPay'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/mine/join/finish',
    component: r => require(['@/views/mine/JoinMemberFinish'], r),
    meta:{keepAlive:false}
  },
  //我的书币
  {
    path:'/mine/mymoney',
    component: r => require(['@/views/mine/MyBookMoney'], r)
  },
  {
    path:'/mine/chargepay',
    component: r => require(['@/views/mine/ChargeWxPay'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/mine/chargefinish',
    component: r => require(['@/views/mine/ChargeFinish'], r),
    meta:{keepAlive:false}
  },
   //图书详细
  {
    path:'/book/detail',
    component: r => require(['@/views/book/BookDetail'], r),
    meta:{isShare:true,keepAlive:false}
  },
   //图书一张图详细全文
   {
    path:'/book/imgdetail',
    component: r => require(['@/views/book/BookImgDetail'], r),
    meta:{isShare:false,keepAlive:false}
  },
  {
    path:'/book/suitdetail',
    component: r => require(['@/views/book/BookSuitDetail'], r),
    meta:{isShare:true,keepAlive:true}
  },
  //阅读
  {
    path:'/book/reader',
    component: r => require(['@/views/book/BookReader'], r)
  },
  //文章详细
  {
    path:'/article/detail',
    component: r => require(['@/views/article/ArticleDetail'], r),
    meta:{isShare:true,keepAlive:false}
  },
  //视频详细
  {
    path:'/video/detail',
    component: r => require(['@/views/lesson/VideoDetail'], r),
    meta:{isShare:true,keepAlive:false}
  },
  //音频播放器
  {
    path:'/audio/detail',
    component: r => require(['@/views/lesson/AudioDetail'], r),
    meta:{isShare:true,keepAlive:false}
  },
  {
    path:'/audio/player',
    component: r => require(['@/views/lesson/Player'], r),
    meta:{isShare:false,keepAlive:false}
  },
  //工具详细
  {
    path:'/tool/detail',
    component: r => require(['@/views/tool/ToolDetail'], r),
    meta:{isShare:true,keepAlive:false}
  },
  {
    path:'/tool/view',
    component: r => require(['@/views/tool/ToolView'], r),
    meta:{isShare:true,keepAlive:false}
  },
  //专家主页
  {
    path:'/expert/detail',
    component: r => require(['@/views/expert/ExpertDetail'], r),
    meta:{isShare:true,keepAlive:true}
  },
  {
    path:'/expert/replylist',
    component: r => require(['@/views/expert/ReplyList'], r)
  },
  //购物车
  {
    path:'/cart/index',
    component: r => require(['@/views/cart/CartIndex'], r),
    meta:{keepAlive:false}
  },
  //结算
  {
    path:'/cart/checkin',
    component: r => require(['@/views/cart/CartCheckIn'], r),
    meta:{keepAlive:false}

  },
  //支付订单
  {
    path:'/order/view',
    component: r => require(['@/views/order/OrderDetail'], r),
    meta:{keepAlive:false}

  },
  {
    path:'/order/trackview',
    component: r => require(['@/views/order/OrderTrack'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/pay/wxqrpay',
    component: r => require(['@/views/order/WxQRPay'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/pay/wxpay',
    component: r => require(['@/views/order/WxPay'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/pay/finish',
    component: r => require(['@/views/order/PayFinish'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/order/media',
    component: r => require(['@/views/order/OrderMedia'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/pay/mwxpay',
    component: r => require(['@/views/order/MediaWxPay'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/pay/mfinish',
    component: r => require(['@/views/order/MediaPayFinish'], r),
    meta:{keepAlive:false}
  },
  
  //增加地址
  {
    path:'/address/add',
    component: r => require(['@/views/address/AddressAdd'], r),
    meta:{keepAlive:false}
  },
  //地址列表
  {
    path:'/address/list',
    component: r => require(['@/views/address/AddressList'], r),
    meta:{keepAlive:false}
  },
  //组件使用方法
  {
    path:'/demo',
    component: r => require(['@/views/Demo'], r),
    meta:{keepAlive:false}
  },

  //关于等
  {
    path:'/etc/about',
    component: r => require(['@/views/etc/About'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/etc/qa',
    component: r => require(['@/views/etc/Qa'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/etc/service',
    component: r => require(['@/views/etc/Service'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/etc/pri',
    component: r => require(['@/views/etc/Pri'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/etc/downapp',
    component: r => require(['@/views/etc/DownApp'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/market/gift',
    component: r => require(['@/views/market/GiftPack'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/market/share',
    component: r => require(['@/views/market/ShareGift'], r),
    meta:{keepAlive:false}
  },
  {
    path:'/market/news',
    component: r => require(['@/views/market/NewsView'], r),
    meta:{keepAlive:false}
  },
  //代理产品
  {
    path:'/agentlesson/list',
    component: r => require(['@/views/agent/AgentProdList'], r),
    meta:{keepAlive:true}
  },
  {
    path:'/agentlesson/detail',
    component: r => require(['@/views/agent/AgentProdView'], r),
    meta:{isShare:true,keepAlive:true}
  },
  {
    path:'/agentpay/wxpay',
    component: r => require(['@/views/agent/WxPay'], r),     
    
    meta:{keepAlive:false}
  },
  {
    path:'/agentpay/finish',
    component: r => require(['@/views/agent/PayFinish'], r),
    meta:{keepAlive:false}
  },
]

const router = new Router({
  base: "/m",
  mode: 'history',
  routes
})

const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach(function (to, from, next) {

    var isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1
    var isApple=(navigator.userAgent.indexOf('iPhone') != -1) || (navigator.userAgent.indexOf('iPod') != -1) ||(navigator.userAgent.indexOf('iPad') != -1)
    // if (("http://www.bracebook.com.cn/m"+to.fullPath != window.location.href) && to.meta.isShare && isWeixin && isApple) {
    //   let href = "http://www.bracebook.com.cn/m"+to.fullPath;
    //   window.location.assign(href);
    // }

    if (!window.initUrl && isWeixin && isApple && to.meta.isShare) {
      window.initUrl = location.href.split('#')[0]
      if(window.initUrl.endsWith('bracebook.com.cn/m')||window.initUrl.endsWith('bracebook.com.cn/m/')){
        window.initUrl ='http://www.bracebook.com.cn/m/find'
      }
    }
  
    // if(to.meta.required_login){W
    //     next("login")
    // }
    //next()//必须写，调到原来的url
    next(vm => {
      vm.path = from.path
    })
})

router.afterEach(function (to, from) {
   //console.log(from)
  // 只用于获取你从哪里来的路由信息
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js